// 模板 12：人力资源与招聘管理平台

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner2.jpg'),
        path: '',
        title: '一体化招聘管理平台',
        content:
          '从职位发布到录用入职，全流程在线管理，提高招聘效率。'
      },
      {
        img: require('@/assets/img/banner_1.jpg'),
        path: '',
        title: '人才库与测评中心',
        content:
          '沉淀企业人才资产，为用人决策提供数据支持。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: 'HR 数据分析中心',
      subtitle: '/ HR Analytics',
      paragraphs: [
        '通过招聘、在职与离职数据分析，帮助 HR 了解组织健康度。',
        '支持多维度数据切片，为人力规划与人才发展提供依据。'
      ],
      buttonText: '预约 HR 方案'
    },
    contact: {
      title: '成长型企业的人力资源助手',
      subTitle: '让每一次招聘与用人成为长期投资',
      buttonText: '联系 HR 顾问'
    },
    customers: [],
    advantages: []
  },
  company: {
    name: '才云人力资源科技有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__专注于人力资源场景的信息化产品，覆盖招聘、绩效与人才发展等多个模块。',
      '我们相信合适的人在合适的位置，是企业长期发展的关键。'
    ]
  },
  news: [
    {
      id: 'HR01',
      title: '发布校园招聘专用模块',
      introduce:
        '支持批量简历筛选与面试安排，帮助企业高效完成校招季。',
      date: '09-01',
      year: '2024'
    },
    {
      id: 'HR02',
      title: '与多家招聘网站打通职位同步',
      introduce:
        '支持在多个招聘平台一键发布与同步职位情况，减少重复操作。',
      date: '05-16',
      year: '2024'
    },
    {
      id: 'HR03',
      title: '候选人测评中心上线',
      introduce:
        '集合多种测评工具，帮助企业更全面了解候选人能力与匹配度。',
      date: '11-29',
      year: '2023'
    },
    {
      id: 'HR04',
      title: 'HR 数据洞察白皮书发布',
      introduce:
        '围绕招聘与流失数据，梳理人力资源管理的关键指标体系。',
      date: '07-10',
      year: '2023'
    },
    {
      id: 'HR05',
      title: '加入人力资源服务联盟',
      introduce:
        '携手多家 HR 服务机构，为客户提供一站式人力解决方案。',
      date: '03-04',
      year: '2022'
    }
  ],
  software: {
    smartTown: {
      title: '招聘管理系统',
      sections: [
        {
          heading: '1. 职位与需求管理',
          content:
            '集中管理各部门岗位需求与招聘进度。'
        },
        {
          heading: '2. 简历筛选与沟通',
          content:
            '支持简历多维度筛选与沟通记录，提升协同效率。'
        },
        {
          heading: '3. 面试流程管理',
          content:
            '统一管理面试安排、反馈与评价，保证流程规范。'
        },
        {
          heading: '4. offer 与入职管理',
          content:
            '从 offer 发送到入职手续办理全流程在线化。'
        }
      ]
    },
    bigData: {
      title: '人力资源数据分析平台',
      sections: [
        {
          heading: '1. 招聘渠道分析',
          desc:
            '对比不同招聘渠道的简历量、面试率与录用率。'
        },
        {
          heading: '2. 招聘周期统计',
          desc:
            '按岗位类别分析平均招聘周期，识别关键岗位招聘难点。'
        },
        {
          heading: '3. 组织健康度看板',
          desc:
            '通过离职率与人均产出等指标，评估组织健康状况。'
        },
        {
          heading: '4. 人才库运营分析',
          desc:
            '统计人才库激活情况，提高人才资源使用效率。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '招聘流程优化咨询',
      engTitle: 'Recruiting Consulting',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: 'HR 系统实施',
      engTitle: 'HRIS Delivery',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '数据指标体系搭建',
      engTitle: 'HR Metrics Design',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '人才发展项目',
      engTitle: 'Talent Development',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: 'HR SaaS 产品经理',
    responsibilities: [
      '负责招聘与 HR 数据相关产品的规划与设计；',
      '研究人力资源管理趋势，结合用户需求持续迭代产品；',
      '与销售与实施团队协同，为客户提供专业支持。'
    ],
    requirements: [
      '具备 HR 或 ToB 产品经验，对人力资源管理有理解；',
      '逻辑清晰，善于沟通与协作；',
      '对数据驱动管理有兴趣。'
    ],
    buttonText: '投递简历'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-12.js